import { render } from "./FeatureFlagFlipper.vue?vue&type=template&id=2fd331c5&ts=true"
import script from "./FeatureFlagFlipper.vue?vue&type=script&lang=ts"
export * from "./FeatureFlagFlipper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__